(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-accordion-01"] && !Shopify.designMode) return;
  try {
    
  class YGAccordion01 extends HTMLElement {
    #sectionEl;

    constructor() {
      super();
      this.currentStepIndex = 0;
      this.mobileSwiper = null;
      this.handleDropdownOpen = this.handleDropdownOpen.bind(this);
      this.handleProgressEnd = this.handleProgressEnd.bind(this);
      this.handleMobileSlideChange = this.handleMobileSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this.#sectionEl) return this.#sectionEl;
      this.#sectionEl = {
        accordionList: this.querySelectorAll('.yg-process-steps-item'),
        progressBars: this.querySelectorAll('.yg-process-steps-progress-bar'),
        desktopControls: this.querySelectorAll('.yg-process-steps-media'),
        mobileControls: this.querySelectorAll('.yg-process-steps-content-media'),
        mobileSwiperElement: this.querySelector('.yg-accordion-mobile-swiper'),
        mobileSwiperSlides: this.querySelectorAll('.yg-accordion-mobile-slide')
      };

      return this.#sectionEl;
    }

    get isMobileSwiperMode() {
      return window.innerWidth <= 699 && this.dataset.mobileSwiperEnabled === 'true';
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.addEventListener('YG:progress-end', this.handleProgressEnd);
      window.addEventListener('resize', this.handleResize);
      this.bindMobileSwiper();

      if (this.isMobileSwiperMode) {
        this.pauseAccordionVideos();
        this.playMobileSwiperVideo();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.removeEventListener('YG:progress-end', this.handleProgressEnd);
      window.removeEventListener('resize', this.handleResize);
      this.unbindMobileSwiper();
      this.pauseAllVideos();
    }

    bindMobileSwiper(retryCount = 12) {
      if (this.dataset.mobileSwiperEnabled !== 'true') {
        return;
      }

      const swiper = this.sectionElements.mobileSwiperElement?.swiper;

      if (!swiper) {
        if (retryCount > 0) {
          window.setTimeout(() => this.bindMobileSwiper(retryCount - 1), 120);
        }
        return;
      }

      if (this.mobileSwiper === swiper) {
        return;
      }

      this.unbindMobileSwiper();
      this.mobileSwiper = swiper;
      this.mobileSwiper.on('slideChange', this.handleMobileSlideChange);
      this.handleMobileSlideChange();
    }

    unbindMobileSwiper() {
      if (this.mobileSwiper?.off) {
        this.mobileSwiper.off('slideChange', this.handleMobileSlideChange);
      }

      this.mobileSwiper = null;
    }

    handleDropdownOpen(event) {
      const id = event.detail?.id;

      if (this.isMobileSwiperMode || !id) {
        return;
      }

      this.currentStep(id);
    }

    handleProgressEnd(event) {
      const id = event.detail?.id;

      if (this.isMobileSwiperMode || !id) {
        return;
      }

      this.nextStep(id);
    }

    handleMobileSlideChange() {
      if (!this.isMobileSwiperMode || !this.mobileSwiper) {
        return;
      }

      this.currentStepIndex = typeof this.mobileSwiper.realIndex === 'number'
        ? this.mobileSwiper.realIndex
        : this.mobileSwiper.activeIndex;

      this.playMobileSwiperVideo(this.currentStepIndex);
    }

    handleResize() {
      if (this.isMobileSwiperMode) {
        this.bindMobileSwiper();
        this.pauseAccordionVideos();
        this.playMobileSwiperVideo();
        return;
      }

      this.pauseMobileSwiperVideos();
    }

    nextStep(id) {
      this.sectionElements.accordionList.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.sectionElements.accordionList.length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });

      if (!this.isCurrentStep(id)) {
        return;
      }
      this.sectionElements.accordionList[this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.sectionElements.accordionList.forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    getEffectiveId(id) {
      let isMobile = window.innerWidth <= 699;
      if (isMobile) {
        return id.replace('steps-item-', 'steps-item-mobile-');
      }
      return id;
    }

    setActiveControl(id) {
      this.sectionElements.desktopControls.forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.sectionElements.progressBars?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      const controlGroups = [...this.sectionElements.desktopControls, ...this.sectionElements.mobileControls];

      controlGroups.forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAccordionVideos() {
      const controlGroups = [...this.sectionElements.desktopControls, ...this.sectionElements.mobileControls];

      controlGroups.forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl && typeof videoEl.pauseVideo === 'function') {
          videoEl.pauseVideo();
        }
      });
    }

    pauseMobileSwiperVideos() {
      this.sectionElements.mobileSwiperSlides.forEach((slide) => {
        const videoEl = slide.querySelector('yg-video');
        if (videoEl && typeof videoEl.pauseVideo === 'function') {
          videoEl.pauseVideo();
        }
      });
    }

    pauseAllVideos() {
      this.pauseAccordionVideos();
      this.pauseMobileSwiperVideos();
    }

    playVideo(id) {
      let effectiveId = this.getEffectiveId(id);
      this.pauseAccordionVideos();
      const videoEl = this.getVideoById(effectiveId);
      if (videoEl && typeof videoEl.playVideo === 'function') {
        videoEl.playVideo();
      }
    }

    playMobileSwiperVideo(index) {
      if (!this.isMobileSwiperMode) {
        return;
      }

      const activeIndex = typeof index === 'number'
        ? index
        : typeof this.mobileSwiper?.realIndex === 'number'
          ? this.mobileSwiper.realIndex
          : this.mobileSwiper?.activeIndex || 0;

      this.pauseMobileSwiperVideos();

      const videoEl = this.sectionElements.mobileSwiperSlides[activeIndex]?.querySelector('yg-video');
      if (videoEl && typeof videoEl.playVideo === 'function') {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-accordion-01')) {
    window.customElements.define('yg-accordion-01', YGAccordion01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion-video-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGAccordionVideo01 extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.mediaQuery = window.matchMedia('(max-width: 699px)');
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return Array.from(this.querySelectorAll('.yg-accordion-item'));
      }

      connectedCallback() {
        this.handleViewportChange();
        this.mediaQuery.addEventListener('change', this.handleViewportChange);
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.handleViewportChange);
        this.destroySwiper();
        this.removeHoverListeners();
      }

      handleViewportChange() {
        if (this.mediaQuery.matches) {
          this.removeHoverListeners();
          this.initSwiper();
          return;
        }

        this.destroySwiper();
        this.addHoverListeners();
        this.activateItem(this.currentActiveItem || this.items[0]);
      }

      initSwiper() {
        if (this.swiperInstance) return;

        const galleryContainer = this.querySelector('.yg-accordion-item-container');
        if (!galleryContainer) return;

        this.items.forEach((item) => item.classList.remove('active'));
        galleryContainer.classList.add('is-visible');

        this.swiperInstance = new Swiper(galleryContainer, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          watchOverflow: true,
          on: {
            init: (swiper) => this.activateMobileSlide(swiper),
            slideChange: (swiper) => this.activateMobileSlide(swiper),
          },
        });
      }

      destroySwiper() {
        if (!this.swiperInstance) return;

        const galleryContainer = this.querySelector('.yg-accordion-item-container');
        const wrapper = this.querySelector('.yg-accordion-item-inner');

        this.swiperInstance.destroy(true, false);
        this.swiperInstance = null;
        galleryContainer?.classList.remove(
          'is-visible',
          'swiper-initialized',
          'swiper-horizontal',
          'swiper-backface-hidden'
        );
        wrapper?.style.removeProperty('transform');
        wrapper?.style.removeProperty('transition-duration');
        wrapper?.style.removeProperty('transition-delay');
        this.items.forEach((item) => {
          item.style.removeProperty('width');
          item.style.removeProperty('margin-right');
          item.style.removeProperty('transform');
        });
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
        });
      }

      handleItemHover(event) {
        this.activateItem(event.currentTarget);
      }

      activateItem(item) {
        if (!item) return;

        this.items.forEach((candidate) => {
          const isActive = candidate === item;
          candidate.classList.toggle('active', isActive);
          this.controlVideo(candidate, isActive ? 'play' : 'pause');
        });
        this.currentActiveItem = item;
      }

      activateMobileSlide(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];

        this.items.forEach((item) => {
          this.controlVideo(item, item === activeSlide ? 'play' : 'pause');
        });
      }

      controlVideo(item, action) {
        item.querySelectorAll('yg-video').forEach((videoElement) => {
          if (videoElement.offsetParent === null) return;

          if (action === 'play' && videoElement.playVideo) {
            videoElement.playVideo();
          }

          if (action === 'pause' && videoElement.pauseVideo) {
            videoElement.pauseVideo();
          }
        });
      }
    }

    if (!window.customElements.get('yg-accordion-video-01')) {
      window.customElements.define('yg-accordion-video-01', YGAccordionVideo01);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-autofocus-showcase"] && !Shopify.designMode) return;
  try {
    
  class YGAutofocusShowcase extends HTMLElement {
    constructor() {
      super();
      this.navObserver = null;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      window.addEventListener('resize', this.handleResize);
      this.observeNavOffset();
      this.syncNavOffset();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);

      if (this.navObserver) {
        this.navObserver.disconnect();
        this.navObserver = null;
      }
    }

    handleResize() {
      this.syncNavOffset();
    }

    observeNavOffset() {
      if (typeof document === 'undefined' || typeof window.ResizeObserver !== 'function') return;

      const nav = document.querySelector('.shopify-section.yg-anchor-tab, .shopify-section.yg-nav');
      if (!nav) return;

      this.navObserver = new window.ResizeObserver(() => this.syncNavOffset());
      this.navObserver.observe(nav);
    }

    syncNavOffset() {
      if (typeof document === 'undefined') return;

      const nav = document.querySelector('.shopify-section.yg-anchor-tab, .shopify-section.yg-nav');
      const navHeight = nav ? Math.round(nav.getBoundingClientRect().height) : 0;
      this.style.setProperty('--autofocus-nav-offset', `${navHeight}px`);
    }
  }

  if (!customElements.get('yg-autofocus-showcase')) {
    customElements.define('yg-autofocus-showcase', YGAutofocusShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-banner-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGBannerSwiper extends HTMLElement {
    connectedCallback() {
      this.bindSwiper();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.bindFrame);
      this.swiper?.off('slideChange', this.updateActiveSlide);
    }

    bindSwiper(attempt = 0) {
      const swiperElement = this.querySelector('yg-swiper');

      if (!swiperElement?.swiper) {
        if (attempt < 120) {
          this.bindFrame = requestAnimationFrame(() => this.bindSwiper(attempt + 1));
        }
        return;
      }

      this.swiper = swiperElement.swiper;
      this.updateActiveSlide = () => {
        const index = this.swiper.realIndex;
        const current = this.querySelector('[data-banner-swiper-current]');
        if (current) current.textContent = String(index + 1);

        this.querySelectorAll('[data-banner-swiper-details]').forEach((el) => {
          const isActive = Number(el.dataset.bannerSwiperDetails) === index;
          el.classList.toggle('is-active', isActive);
          el.toggleAttribute('aria-hidden', !isActive);
        });
      };
      this.swiper.on('slideChange', this.updateActiveSlide);
      this.updateActiveSlide();
    }
  }

  if (!customElements.get('yg-banner-swiper')) {
    customElements.define('yg-banner-swiper', YGBannerSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-download-tab"] && !Shopify.designMode) return;
  try {
    
  class YGDownloadTab extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.scheduleLayoutUpdate = this.scheduleLayoutUpdate.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.downloadRequests = new Map();
      this.downloadUrls = new Map();
    }

    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.tabList = this.querySelector('[data-tab-list]');
      this.tabViewport = this.querySelector('[data-tab-viewport]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('resize', this.scheduleLayoutUpdate);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.scheduleLayoutUpdate);
        if (this.tabList) this.resizeObserver.observe(this.tabList);
        if (this.tabViewport) this.resizeObserver.observe(this.tabViewport);
      }
      this.scheduleLayoutUpdate();
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.scheduleLayoutUpdate();
      });
    }

    disconnectedCallback() {
      this.isInitialized = false;
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('resize', this.scheduleLayoutUpdate);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = null;
      this.downloadRequests.forEach((controller, link) => {
        controller.abort();
        link.removeAttribute('aria-busy');
      });
      this.downloadRequests.clear();
      this.downloadUrls.forEach((timer, url) => {
        clearTimeout(timer);
        URL.revokeObjectURL(url);
      });
      this.downloadUrls.clear();
    }

    get isMobile() {
      return window.matchMedia('(max-width: 699px)').matches;
    }

    handleClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (tab && this.contains(tab)) {
        this.activateTab(tab);
        return;
      }
      const link = event.target.closest('[data-download]');
      if (!link || !this.contains(link)) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (!this.downloadRequests.has(link)) this.downloadFile(link);
    }

    handleKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.tabs.includes(tab)) return;
      const index = this.tabs.indexOf(tab);
      let nextIndex;
      if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else if (event.key === (this.isMobile ? 'ArrowLeft' : 'ArrowUp')) {
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === (this.isMobile ? 'ArrowRight' : 'ArrowDown')) {
        nextIndex = (index + 1) % this.tabs.length;
      } else {
        return;
      }
      event.preventDefault();
      this.activateTab(this.tabs[nextIndex], true);
    }

    handleBlockSelect(event) {
      const tab = this.tabs.find((item) => item.dataset.tabTarget === event.detail?.blockId);
      if (tab) this.activateTab(tab);
    }

    activateTab(tab, shouldFocus = false) {
      if (!this.tabs.includes(tab)) return;
      this.tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== tab.dataset.tabTarget;
      });
      if (shouldFocus) tab.focus({ preventScroll: true });
      if (this.isMobile && this.tabViewport) {
        const viewportRect = this.tabViewport.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const scrollLeft =
          this.tabViewport.scrollLeft +
          tabRect.left -
          viewportRect.left -
          (this.tabViewport.clientWidth - tabRect.width) / 2;
        this.tabViewport.scrollTo({
          left: Math.max(0, Math.min(scrollLeft, this.tabViewport.scrollWidth - this.tabViewport.clientWidth)),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
      this.scheduleLayoutUpdate();
    }

    scheduleLayoutUpdate() {
      if (this.layoutFrame) return;
      this.layoutFrame = requestAnimationFrame(() => {
        this.layoutFrame = null;
        const tab = this.tabs.find((item) => item.classList.contains('is-active'));
        if (!tab || !this.tabList || !this.tabViewport?.clientWidth) return;
        this.tabList.setAttribute('aria-orientation', this.isMobile ? 'horizontal' : 'vertical');
        this.tabList.style.setProperty(
          '--yg-download-tab-indicator-offset',
          `${this.isMobile ? tab.offsetLeft : tab.offsetTop}px`
        );
        this.tabList.style.setProperty(
          '--yg-download-tab-indicator-length',
          `${this.isMobile ? tab.offsetWidth : tab.offsetHeight}px`
        );
      });
    }

    async downloadFile(link) {
      const controller = new AbortController();
      this.downloadRequests.set(link, controller);
      link.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(link.href, { signal: controller.signal });
        if (!response.ok) throw new Error('Download request failed.');
        const blob = await response.blob();
        if (controller.signal.aborted || !this.isConnected) return;
        const url = URL.createObjectURL(blob);
        let filename = new URL(link.href).pathname.split('/').pop() || 'download';
        try {
          filename = decodeURIComponent(filename);
        } catch {
          // Keep the URL filename when percent encoding is malformed.
        }
        const timer = setTimeout(() => {
          URL.revokeObjectURL(url);
          this.downloadUrls.delete(url);
        }, 60000);
        this.downloadUrls.set(url, timer);
        this.triggerDownload(url, filename);
      } catch {
        if (!controller.signal.aborted && this.isConnected) this.triggerDownload(link.href);
      } finally {
        if (this.downloadRequests.get(link) === controller) {
          this.downloadRequests.delete(link);
          link.removeAttribute('aria-busy');
        }
      }
    }

    triggerDownload(url, filename) {
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.hidden = true;
      if (filename) {
        anchor.download = filename;
      } else {
        anchor.target = '_self';
      }
      this.appendChild(anchor);
      anchor.click();
      anchor.remove();
    }
  }

  if (!window.customElements.get('yg-download-tab')) {
    window.customElements.define('yg-download-tab', YGDownloadTab);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-focal-length-sticky"] && !Shopify.designMode) return;
  try {
    
  class YGFocalLengthSticky extends HTMLElement {
    constructor() {
      super();
      this.animationFrame = null;
      this.activeIndex = -1;
      this.programmaticScroll = false;
      this.unlockTimer = null;
      this.navObserver = null;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.unlockProgrammaticScroll = this.unlockProgrammaticScroll.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-focal-item]'));
      this.mediaItems = Array.from(this.querySelectorAll('[data-focal-media]'));
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      if (typeof this.addEventListener === 'function') {
        this.addEventListener('click', this.handleClick);
      }

      this.observeNavOffset();
      this.syncNavOffset();
      this.setActiveIndex(0);
      this.requestTick();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scrollend', this.unlockProgrammaticScroll);

      if (typeof this.removeEventListener === 'function') {
        this.removeEventListener('click', this.handleClick);
      }

      if (this.navObserver) {
        this.navObserver.disconnect();
        this.navObserver = null;
      }

      if (this.unlockTimer !== null) {
        clearTimeout(this.unlockTimer);
        this.unlockTimer = null;
      }

      if (this.animationFrame !== null) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }
    }

    handleScroll() {
      this.requestTick();
    }

    handleResize() {
      this.syncNavOffset();
      this.requestTick();
    }

    handleClick(event) {
      const item = event.target.closest('[data-focal-item]');
      if (!item || !this.contains(item)) return;

      const nextIndex = this.items.indexOf(item);
      this.goToIndex(nextIndex);
    }

    observeNavOffset() {
      if (typeof document === 'undefined' || typeof window.ResizeObserver !== 'function') return;

      const nav = document.querySelector('.shopify-section.yg-anchor-tab, .shopify-section.yg-nav');
      if (!nav) return;

      this.navObserver = new window.ResizeObserver(() => this.syncNavOffset());
      this.navObserver.observe(nav);
    }

    syncNavOffset() {
      if (typeof document === 'undefined') return;

      const nav = document.querySelector('.shopify-section.yg-anchor-tab, .shopify-section.yg-nav');
      const navHeight = nav ? Math.round(nav.getBoundingClientRect().height) : 0;
      this.style.setProperty('--focal-nav-offset', `${navHeight}px`);
    }

    requestTick() {
      if (this.animationFrame !== null) return;

      this.animationFrame = requestAnimationFrame(() => this.updateActiveIndex());
    }

    getActiveIndex(scrollDistance, viewportHeight, itemCount) {
      if (itemCount <= 0) return -1;
      if (itemCount === 1) return 0;

      const safeViewportHeight = Math.max(viewportHeight, 1);
      const nextIndex = Math.floor(Math.max(scrollDistance, 0) / safeViewportHeight);

      return Math.max(0, Math.min(itemCount - 1, nextIndex));
    }

    updateActiveIndex() {
      this.animationFrame = null;
      if (this.programmaticScroll) return;

      const viewportHeight = window.innerHeight || (typeof document !== 'undefined' && document.documentElement.clientHeight) || 1;
      const scrollDistance = Math.max(0, -this.getBoundingClientRect().top);
      const nextIndex = this.getActiveIndex(scrollDistance, viewportHeight, this.items.length);

      this.setActiveIndex(nextIndex);
    }

    goToIndex(nextIndex) {
      if (nextIndex < 0 || nextIndex >= this.items.length) return;

      this.setActiveIndex(nextIndex);

      const viewportHeight = window.innerHeight || (typeof document !== 'undefined' && document.documentElement.clientHeight) || 1;
      const trackTop = (window.scrollY || 0) + this.getBoundingClientRect().top;
      const top = trackTop + nextIndex * viewportHeight;
      const reduceMotion =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.programmaticScroll = true;

      if (typeof window.scrollTo === 'function') {
        window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      window.removeEventListener('scrollend', this.unlockProgrammaticScroll);
      window.addEventListener('scrollend', this.unlockProgrammaticScroll, { once: true });

      if (this.unlockTimer !== null) clearTimeout(this.unlockTimer);
      this.unlockTimer = setTimeout(this.unlockProgrammaticScroll, reduceMotion ? 50 : 800);
    }

    unlockProgrammaticScroll() {
      this.programmaticScroll = false;

      if (this.unlockTimer !== null) {
        clearTimeout(this.unlockTimer);
        this.unlockTimer = null;
      }

      window.removeEventListener('scrollend', this.unlockProgrammaticScroll);
      this.requestTick();
    }

    setActiveIndex(nextIndex) {
      if (nextIndex < 0 || nextIndex === this.activeIndex) return;

      this.items.forEach((item, index) => {
        const isActive = index === nextIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this.mediaItems.forEach((mediaItem, index) => {
        const isActive = index === nextIndex;
        mediaItem.classList.toggle('is-active', isActive);
        mediaItem.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.activeIndex = nextIndex;
    }
  }

  if (!customElements.get('yg-focal-length-sticky')) {
    customElements.define('yg-focal-length-sticky', YGFocalLengthSticky);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-guide-swiper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-guide-swiper')) {
    class YGGuideSwiper extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
        this.handleBlockSelect = this.selectBlock.bind(this);
        this.handleFocus = this.revealFocusedSlide.bind(this);
      }

      connectedCallback() {
        if (this.swiper) return;
        const track = this.querySelector('.yg-guide-swiper__track');
        if (!track || !track.querySelector('.yg-guide-swiper__slide')) return;

        track.dataset.breakpoints = `0:auto-${track.dataset.guideSwiperGapMobile},700:auto-${track.dataset.guideSwiperGap}`;
        track.dataset.speed = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? '0' : '300';
        this.swiper = this.initSwiper(track);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.addEventListener('focusin', this.handleFocus);
      }

      disconnectedCallback() {
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.removeEventListener('focusin', this.handleFocus);
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }

      selectBlock(event) {
        const slide = Array.from(this.querySelectorAll('.yg-guide-swiper__slide')).find(
          (item) => item.dataset.blockId === event.detail?.blockId
        );
        this.revealSlide(slide);
      }

      revealFocusedSlide(event) {
        this.revealSlide(event.target.closest('.yg-guide-swiper__slide'));
      }

      revealSlide(slide) {
        if (!this.swiper || !slide) return;
        const index = Array.from(this.swiper.slides).indexOf(slide);
        if (index >= 0) this.swiper.slideTo(index);
      }
    }

    customElements.define('yg-guide-swiper', YGGuideSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-comment"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-nav"] && !Shopify.designMode) return;
  try {
    
  // Section HTML can be replaced by the theme editor without executing its module script tags.
  function loadYGNavDownload(root) {
    const nav = root.querySelector('yg-anchor-tab[data-download-module-url]');
    if (nav && nav.querySelector('yg-nav-download')) {
      import(nav.dataset.downloadModuleUrl).catch((error) => console.error('Unable to load navigation downloads', error));
    }
  }
  loadYGNavDownload(document);
  document.addEventListener('shopify:section:load', (event) => loadYGNavDownload(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-compare-v3"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // 让 Vue 忽略以 yg- 开头的自定义标签（如 yg-image、yg-select 等），避免 Unknown custom element 报错
    if (window.Vue && Vue.config) {
      Vue.config.ignoredElements = Vue.config.ignoredElements || [];
      Vue.config.ignoredElements.push(/^yg-/);
    }

    class YGProductCompareV3 extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleWindowScroll = this.handleWindowScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleTopBarScroll = this.handleTopBarScroll.bind(this);
        this.handleFloatingTopBarScroll = this.handleFloatingTopBarScroll.bind(this);
        this.handleTopScroll = this.handleTopScroll.bind(this);
        this.handleDataScroll = this.handleDataScroll.bind(this);
      }
      get isFloatingTopBarEnabled() {
        return this.dataset.enableFloatingTopBar === 'true';
      }
      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;
        this._sectionsEl = {
          'product-form': this.querySelector('#yg-product-form') || this.querySelector('.yg-product-form'),
          'product-form-id': this.querySelector('#yg-product-form-id') || this.querySelector('.yg-product-form-id'),
          'product-data': this.querySelector('.yg-product-data'),
          'product-top-bar-shell': this.querySelector('.yg-product-top-bar-shell'),
          'product-top-bar-scroll': this.querySelector('.yg-product-compare-top-bar-container'),
          'floating-top-bar-shell': this.querySelector('.yg-product-floating-top-bar-shell'),
          'floating-top-bar-scroll': this.querySelector('.yg-product-floating-top-bar-container'),
          'product-top-scroll': this.querySelector('.yg-product-compare-top-container'),
          'product-data-scroll': this.querySelector('.yg-product-compare-data-container'),
        };

        return this._sectionsEl;
      }
      connectedCallback() {
        this.initVue();

        if (!this._eventsBound) {
          this.addEventListener('click', this.handleClick);
          window.addEventListener('resize', this.handleResize);
          this.sectionsEl['product-top-bar-scroll']?.addEventListener('scroll', this.handleTopBarScroll, {
            passive: true,
          });
          this.sectionsEl['product-top-scroll']?.addEventListener('scroll', this.handleTopScroll, { passive: true });
          this.sectionsEl['product-data-scroll']?.addEventListener('scroll', this.handleDataScroll, { passive: true });
          if (this.isFloatingTopBarEnabled) {
            window.addEventListener('scroll', this.handleWindowScroll, { passive: true });
            this.sectionsEl['floating-top-bar-scroll']?.addEventListener('scroll', this.handleFloatingTopBarScroll, {
              passive: true,
            });
          }
          this._eventsBound = true;
        }

        this.handleResize();
        this.refreshDynamicHeights();
        if (this.isFloatingTopBarEnabled) {
          this.requestFloatingNavStateUpdate();
        }
      }
      disconnectedCallback() {
        if (!this._eventsBound) return;

        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('resize', this.handleResize);
        this.sectionsEl['product-top-bar-scroll']?.removeEventListener('scroll', this.handleTopBarScroll);
        this.sectionsEl['product-top-scroll']?.removeEventListener('scroll', this.handleTopScroll);
        this.sectionsEl['product-data-scroll']?.removeEventListener('scroll', this.handleDataScroll);
        if (this.isFloatingTopBarEnabled) {
          window.removeEventListener('scroll', this.handleWindowScroll);
          this.sectionsEl['floating-top-bar-scroll']?.removeEventListener('scroll', this.handleFloatingTopBarScroll);
          this.closeTopBarDropdowns();
        }
        if (this._floatingNavFrame) {
          cancelAnimationFrame(this._floatingNavFrame);
          this._floatingNavFrame = null;
        }
        this._eventsBound = false;
      }
      initVue() {
        if (this._vue) return;

        if (!window.Vue || !window.ELEMENT) {
          console.warn('[yg-product-compare-v3] Vue or Element UI is not available.');
          return;
        }

        let _this = this;
        this._vue = new Vue({
          el: _this.querySelector('.yg-select-vue'),
          delimiters: ['${', '}'],
          data() {
            let initialState = {
              options: [],
              values: [],
              hideDuplicates: false,
              primaryRowCount: 0,
              groupRowCounts: {},
              isCondensedLayout: false,
              variantsCurrent: [
                { id: null, price: null, featured_image: null, available: null },
                { id: null, price: null, featured_image: null, available: null },
                { id: null, price: null, featured_image: null, available: null },
              ],
            };

            const textarea = _this.querySelector('#compare-data');
            if (textarea) {
              const raw = (textarea.value || textarea.textContent || '').trim();
              if (raw) {
                let parsed;
                try {
                  parsed = JSON.parse(raw);
                } catch (error) {
                  parsed = new Function('return ' + raw)();
                }
                if (parsed && Array.isArray(parsed.options)) {
                  initialState.options = parsed.options;
                }

                initialState.values = initialState.options.slice(0, 3).map((opt) => opt.value);
                initialState.variantsCurrent = [];
                initialState.values.forEach((handle) => {
                  const opt = initialState.options.find((option) => option && option.value === handle);
                  const variants = opt && opt.data && Array.isArray(opt.data.variants) ? opt.data.variants : [];
                  const firstVariant = variants[0] || null;
                  initialState.variantsCurrent.push({
                    id: firstVariant ? firstVariant.id : null,
                    price: firstVariant ? firstVariant.price : null,
                    featured_image:
                      firstVariant && firstVariant.featured_image ? firstVariant.featured_image.src : null,
                    available: firstVariant ? firstVariant.available : null,
                  });
                });

                while (initialState.variantsCurrent.length < 3) {
                  initialState.variantsCurrent.push({
                    id: null,
                    price: null,
                    featured_image: null,
                    available: null,
                  });
                }
              }
            }

            return initialState;
          },
          mounted() {
            this.primaryRowCount = _this.querySelectorAll('.yg-product-data-group > .row').length;

            const groupRowCounts = {};
            _this.querySelectorAll('.yg-product-dropdown-wrap').forEach((groupWrap) => {
              const groupIndex = Number(groupWrap.dataset.groupIndex);
              if (Number.isNaN(groupIndex)) return;
              groupRowCounts[groupIndex] = groupWrap.querySelectorAll('.row').length;
            });
            this.groupRowCounts = groupRowCounts;

            _this.syncResponsiveState();
            this.handleSpecificationVisibilityChange();
          },
          watch: {
            hideDuplicates() {
              this.handleSpecificationVisibilityChange();
            },
            values: {
              deep: true,
              handler() {
                this.handleSpecificationVisibilityChange();
              },
            },
            isCondensedLayout() {
              this.handleSpecificationVisibilityChange();
            },
          },
          methods: {
            formatMoney(cents) {
              const format = _this.getAttribute('data-currency-format');
              const valueNumber = Number(cents) || 0;
              const amount = valueNumber / 100;
              const amountStr = amount.toFixed(2);
              return format + amountStr;
            },
            handleProductChange(columnIndex, newColumnValue) {
              const variants = (this.variantsMap && this.variantsMap[newColumnValue]) || [];
              const nextVariant = variants[0] || null;
              const nextId = nextVariant ? nextVariant.id : null;

              this.$set(this.variantsCurrent, columnIndex, {
                id: nextId,
                price: nextVariant ? nextVariant.price : null,
                featured_image: nextVariant && nextVariant.featured_image ? nextVariant.featured_image.src : null,
                available: nextVariant ? nextVariant.available : null,
              });
              if (nextId != null) this.handleVariantChange(newColumnValue, nextId, columnIndex);
            },
            handleVariantChange(columnValue, variantId, columnIndex) {
              const variants = (this.variantsMap && this.variantsMap[columnValue]) || [];
              const selected = variants.find((variant) => variant && String(variant.id) === String(variantId)) || null;
              const price = selected ? selected.price : null;
              const featuredImage = selected && selected.featured_image ? selected.featured_image.src : null;
              const available = selected ? selected.available : null;

              if (typeof columnIndex === 'number') {
                const previous = (this.variantsCurrent && this.variantsCurrent[columnIndex]) || {};
                this.$set(this.variantsCurrent, columnIndex, {
                  ...previous,
                  id: variantId,
                  price,
                  featured_image: featuredImage,
                  available,
                });
              }
            },
            getVariantOptionValue(columnValue, item) {
              const position = (this.variantPositionMap && this.variantPositionMap[columnValue]) || 1;
              const key = 'option' + String(position);
              return (item && item[key]) || (item && item.public_title) || '';
            },
            getVariantLabel(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              return value || (item && item.public_title) || '';
            },
            getColorSwatchStyle(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              const key = String(value || '')
                .toLowerCase()
                .trim();
              const map = (this.colorSwatchMap && this.colorSwatchMap[columnValue]) || {};
              return map[key] || '';
            },
            buildMapFromOptions(getValueFn) {
              const map = {};
              (this.options || []).forEach((option) => {
                if (!option || option.value == null) return;
                const value = getValueFn(option);
                if (value != null) {
                  map[option.value] = value;
                }
              });
              return map;
            },
            normalizeComparableValue(value) {
              if (value == null) return '';
              return String(value).trim();
            },
            getVisibleColumnIndices() {
              const maxCount = this.isCondensedLayout ? 2 : Math.min(this.values.length, 3);
              return this.values
                .slice(0, maxCount)
                .map((_, index) => index)
                .filter((index) => this.values[index]);
            },
            shouldHideComparableValues(values) {
              if (!this.hideDuplicates || values.length < 2) return false;
              const firstValue = values[0];
              return values.every((value) => value === firstValue);
            },
            getPrimaryRowComparableValue(columnIndex, rowIndex) {
              const handle = this.values[columnIndex];
              if (!handle) return '';
              const imageValue = (this.specificationImageMap[handle] || [])[rowIndex] || '';
              const textValue = (this.specificationListMap[handle] || [])[rowIndex] || '';
              return [this.normalizeComparableValue(imageValue), this.normalizeComparableValue(textValue)].join('||');
            },
            shouldHidePrimaryRow(rowIndex) {
              const rowValues = this.getVisibleColumnIndices().map((columnIndex) =>
                this.getPrimaryRowComparableValue(columnIndex, rowIndex)
              );
              return this.shouldHideComparableValues(rowValues);
            },
            getGroupSpecificationMap(groupIndex) {
              const groupMaps = {
                1: this.specificationListGroup1Map,
                2: this.specificationListGroup2Map,
                3: this.specificationListGroup3Map,
                4: this.specificationListGroup4Map,
                5: this.specificationListGroup5Map,
              };
              return groupMaps[groupIndex] || {};
            },
            getGroupRowDisplayValue(groupIndex, columnIndex, rowIndex) {
              const handle = this.values[columnIndex];
              if (!handle) return '';
              const groupMap = this.getGroupSpecificationMap(groupIndex);
              const rawValue = (groupMap[handle] || [])[rowIndex];
              if (rawValue === '.') return '.';
              if (rawValue == null || rawValue === '') return '-';
              return this.normalizeComparableValue(rawValue);
            },
            shouldHideGroupRow(groupIndex, rowIndex) {
              const rowValues = this.getVisibleColumnIndices().map((columnIndex) =>
                this.getGroupRowDisplayValue(groupIndex, columnIndex, rowIndex)
              );
              return this.shouldHideComparableValues(rowValues);
            },
            isGroupFullyHidden(groupIndex, rowCount) {
              if (!this.hideDuplicates) return false;
              const totalRows = Number(rowCount) || 0;
              if (totalRows === 0) return true;

              for (let rowIndex = 0; rowIndex < totalRows; rowIndex += 1) {
                if (!this.shouldHideGroupRow(groupIndex, rowIndex)) {
                  return false;
                }
              }

              return true;
            },
            hasVisiblePrimaryRows() {
              const totalRows = Number(this.primaryRowCount) || 0;
              for (let rowIndex = 0; rowIndex < totalRows; rowIndex += 1) {
                if (!this.shouldHidePrimaryRow(rowIndex)) {
                  return true;
                }
              }

              return false;
            },
            hasVisibleGroupedRows() {
              const groupRowCounts = this.groupRowCounts || {};
              return Object.keys(groupRowCounts).some((groupIndex) => {
                return !this.isGroupFullyHidden(Number(groupIndex), groupRowCounts[groupIndex]);
              });
            },
            handleSpecificationVisibilityChange() {
              this.$nextTick(() => {
                _this.refreshDynamicHeights();
              });
            },
          },
          computed: {
            imageMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.product_image);
            },
            productTitleMap() {
              return this.buildMapFromOptions((option) => option.label);
            },
            variantsMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.variants);
            },
            variantPositionMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.variant_position);
            },
            colorSwatchMap() {
              return this.buildMapFromOptions((option) => {
                const rows =
                  option && option.data && Array.isArray(option.data.color_swatch_config)
                    ? option.data.color_swatch_config
                    : [];
                const map = {};
                rows.forEach((row) => {
                  if (!row || row.label == null) return;
                  const key = String(row.label).toLowerCase().trim();
                  const value = row.value;
                  if (key && value) map[key] = value;
                });
                return map;
              });
            },
            specificationImageMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_image);
            },
            specificationListMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list);
            },
            minPriceMap() {
              return this.buildMapFromOptions((option) => option.min_price);
            },
            priceMap() {
              return this.buildMapFromOptions((option) => option.price);
            },
            productUrlMap() {
              return this.buildMapFromOptions((option) => option.product_url);
            },
            specificationListGroup1Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_1);
            },
            specificationListGroup2Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_2);
            },
            specificationListGroup3Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_3);
            },
            specificationListGroup4Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_4);
            },
            specificationListGroup5Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_5);
            },
            hasVisibleComparisonData() {
              return this.hasVisiblePrimaryRows() || this.hasVisibleGroupedRows();
            },
          },
        });
      }
      handleClick(event) {
        const addButton =
          event.target && event.target.closest ? event.target.closest('.yg-product-button-add-to-cart') : null;
        if (!addButton || !this.contains(addButton)) return;

        event.preventDefault?.();
        this.handleAddToCart(addButton);
      }
      handleResize() {
        this.syncResponsiveState();
        this.refreshDynamicHeights();
        if (this.isFloatingTopBarEnabled) {
          this.requestFloatingNavStateUpdate();
        }
      }
      handleWindowScroll() {
        if (!this.isFloatingTopBarEnabled) return;
        this.requestFloatingNavStateUpdate();
      }
      handleTopBarScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['floating-top-bar-scroll', 'product-top-scroll', 'product-data-scroll']
          : ['product-top-scroll', 'product-data-scroll'];
        this.syncScroll('product-top-bar-scroll', targetKeys);
      }
      handleFloatingTopBarScroll() {
        if (!this.isFloatingTopBarEnabled) return;
        this.syncScroll('floating-top-bar-scroll', [
          'product-top-bar-scroll',
          'product-top-scroll',
          'product-data-scroll',
        ]);
      }
      handleTopScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['product-top-bar-scroll', 'floating-top-bar-scroll', 'product-data-scroll']
          : ['product-top-bar-scroll', 'product-data-scroll'];
        this.syncScroll('product-top-scroll', targetKeys);
      }
      handleDataScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['product-top-bar-scroll', 'floating-top-bar-scroll', 'product-top-scroll']
          : ['product-top-bar-scroll', 'product-top-scroll'];
        this.syncScroll('product-data-scroll', targetKeys);
      }
      syncScroll(sourceKey, targetKeys) {
        const source = this.sectionsEl[sourceKey];
        const nextTargetKeys = Array.isArray(targetKeys) ? targetKeys : [targetKeys];

        if (!source || this._syncingScroll) return;

        this._syncingScroll = true;
        nextTargetKeys.forEach((targetKey) => {
          const target = this.sectionsEl[targetKey];
          if (!target || target === source) return;
          if (target.scrollLeft === source.scrollLeft) return;
          target.scrollLeft = source.scrollLeft;
        });
        requestAnimationFrame(() => {
          this._syncingScroll = false;
        });
      }
      syncResponsiveState() {
        if (!this._vue) return;

        const isCondensedLayout =
          this.classList.contains('show-product-select') && window.matchMedia('(max-width: 1150px)').matches;
        this._vue.isCondensedLayout = isCondensedLayout;
      }
      closeTopBarDropdowns() {
        this.querySelectorAll('.yg-product-select').forEach((selectEl) => {
          const instance = selectEl.__vue__;
          if (!instance) return;

          if (typeof instance.blur === 'function') {
            instance.blur();
          }

          if ('visible' in instance) {
            instance.visible = false;
          }
        });

        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        document.querySelectorAll(`.yg-product-compare-top-popper-${sectionId}`).forEach((popper) => {
          popper.style.display = 'none';
          popper.setAttribute('aria-hidden', 'true');
        });
      }
      getFloatingNavTopOffset() {
        const styles = getComputedStyle(this);
        const headerHeightValue = parseFloat(styles.getPropertyValue('--header-height'));
        const headerVisibleValue = parseFloat(styles.getPropertyValue('--header-is-visible'));
        const headerHeight = Number.isFinite(headerHeightValue) ? headerHeightValue : 0;
        const headerVisible = Number.isFinite(headerVisibleValue) ? headerVisibleValue : 1;
        return Math.max(0, (headerHeight - 1.5) * headerVisible);
      }
      requestFloatingNavStateUpdate() {
        if (!this.isFloatingTopBarEnabled) return;
        if (this._floatingNavFrame) return;

        this._floatingNavFrame = requestAnimationFrame(() => {
          this._floatingNavFrame = null;
          this.updateFloatingNavState();
        });
      }
      updateFloatingNavState() {
        if (!this.isFloatingTopBarEnabled) return;
        const floatingShell = this.sectionsEl['floating-top-bar-shell'];
        const sourceShell = this.sectionsEl['product-top-bar-shell'];
        const sourceScroll = this.sectionsEl['product-top-bar-scroll'];
        if (!floatingShell || !sourceShell || !sourceScroll) return;

        const stickyTop = this.getFloatingNavTopOffset();
        const sectionRect = this.getBoundingClientRect();
        const sourceShellRect = sourceShell.getBoundingClientRect();
        const sourceScrollRect = sourceScroll.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

        const isSectionVisible = sectionRect.top < viewportHeight && sectionRect.bottom > stickyTop;
        const hasSourceBarScrolledOut = sourceShellRect.bottom <= stickyTop;
        const shouldShowFloating = isSectionVisible && hasSourceBarScrolledOut;
        const wasFloatingActive = floatingShell.classList.contains('is-active');

        this.style.setProperty('--floating-nav-top', `${stickyTop}px`);
        this.style.setProperty('--floating-nav-left', `${sourceScrollRect.left}px`);
        this.style.setProperty('--floating-nav-width', `${sourceScrollRect.width}px`);

        if (wasFloatingActive !== shouldShowFloating) {
          this.closeTopBarDropdowns();
        }

        floatingShell.classList.toggle('is-active', shouldShowFloating);
        floatingShell.setAttribute('aria-hidden', shouldShowFloating ? 'false' : 'true');
      }
      refreshDynamicHeights() {
        requestAnimationFrame(() => {
          this.syncDropdownHeights();
          this.refreshCollapseButtons();
          const productData = this.sectionsEl['product-data'];
          if (productData && productData.hasAttribute('open')) {
            productData.style.height = 'auto';
          }
          if (this.isFloatingTopBarEnabled) {
            this.requestFloatingNavStateUpdate();
          }
        });
      }
      syncDropdownHeights() {
        this.querySelectorAll('yg-dropdown').forEach((dropdown) => {
          dropdown.setContentContainerHeight?.();
        });
      }
      refreshCollapseButtons() {
        this.querySelectorAll('yg-collapse-button').forEach((button) => {
          button.refresh?.();
        });
      }
      handleAddToCart(item) {
        const variantId = item?.dataset?.variantId || item?.getAttribute?.('data-variant-id');

        if (!variantId && !item.classList.contains('disabled')) return;

        const form = this.sectionsEl['product-form'];
        const idInput = this.sectionsEl['product-form-id'];
        if (!form || !idInput) return;

        idInput.value = String(variantId);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        idInput.dispatchEvent(new Event('input', { bubbles: true }));

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
          return;
        }

        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn && typeof submitBtn.click === 'function') {
          submitBtn.click();
          return;
        }

        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
    if (!window.customElements.get('yg-product-compare-v3')) {
      window.customElements.define('yg-product-compare-v3', YGProductCompareV3);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-variant-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGProductVariantTabs extends HTMLElement {
    connectedCallback() {
      this.connectionId = (this.connectionId || 0) + 1;
      const connectionId = this.connectionId;
      Promise.all([customElements.whenDefined('yg-tabs-title'), customElements.whenDefined('yg-swiper')]).then(() => {
        if (this.isConnected && connectionId === this.connectionId) {
          this.initialize();
        }
      });
    }

    disconnectedCallback() {
      this.connectionId += 1;
      this.abortController?.abort();
      this.tabObserver?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.animationFrame);
      this.panelStates?.forEach((state, panel) => {
        state.request?.abort();
        if (state.pending) {
          panel.querySelector('[data-yg-options]').innerHTML = state.confirmedOptions;
          this.setVariant(panel, state.variant);
          panel.removeAttribute('aria-busy');
        }
      });
      this.swipers?.forEach((swiper) => swiper.destroy(true, true));
      this.swipers?.clear();
    }

    initialize() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.swipers = new Map();
      this.panelStates = new Map();
      this.$titles = this.querySelector('yg-tabs-title');
      this.$scroll = this.querySelector('.yg-scroll-container');
      this.$scrollPrev = this.querySelector('.yg-variant-tabs__scroll-prev');
      this.$scrollNext = this.querySelector('.yg-variant-tabs__scroll-next');
      this.$tabButtons = Array.from(this.$titles.children);
      this.$panels = Array.from(this.querySelector('yg-tabs-content').children);
      this.$titles.setAttribute('role', 'tablist');
      this.$titles.setAttribute('aria-orientation', 'horizontal');

      this.$panels.forEach((panel) => {
        this.panelStates.set(panel, {
          variant: this.getVariant(panel),
          confirmedOptions: panel.querySelector('[data-yg-options]').innerHTML,
          requestId: 0,
          pending: false,
        });
        this.setVariant(panel, this.getVariant(panel));
      });

      const listenerOptions = { signal: this.abortController.signal };
      this.addEventListener('change', (event) => this.handleOptionChange(event), listenerOptions);
      this.addEventListener('click', (event) => this.handleClick(event), listenerOptions);
      this.$titles.addEventListener('keydown', (event) => this.handleTabKeydown(event), listenerOptions);
      this.$scroll.addEventListener('scroll', () => this.updateNavigation(), listenerOptions);
      this.addEventListener(
        'shopify:block:select',
        (event) => {
          const index = this.$panels.findIndex((panel) => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) {
            this.selectTab(index);
          }
        },
        listenerOptions
      );

      this.tabObserver = new MutationObserver(() => this.syncTabs());
      this.tabObserver.observe(this.$titles, { subtree: true, attributes: true, attributeFilter: ['class'] });
      this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
      this.resizeObserver.observe(this.querySelector('.yg-variant-tabs__navigation'));
      this.selectTab(Math.min(this.selectedIndex || 0, this.$tabButtons.length - 1));
      document.fonts?.ready.then(() => {
        if (this.isConnected) {
          this.scheduleLayout();
        }
      });
    }

    getVariant(panel) {
      return JSON.parse(panel.querySelector('[data-yg-variant-state]').textContent);
    }

    getOptionValues(panel) {
      return Array.from(panel.querySelectorAll('[data-yg-options] input[data-option-position]:checked'))
        .sort((first, second) => Number(first.dataset.optionPosition) - Number(second.dataset.optionPosition))
        .map((input) => input.value);
    }

    selectTab(index) {
      if (index < 0 || index >= this.$tabButtons.length) {
        return;
      }
      this.selectedIndex = index;
      this.$titles.toggleClass(this.$tabButtons[index], index);
      this.$titles.scrollItemIntoView(this.$tabButtons[index]);
      this.syncTabs();
    }

    syncTabs() {
      const activeIndex = this.$tabButtons.findIndex((button) => button.classList.contains('is-active'));
      if (activeIndex < 0) {
        return;
      }
      this.selectedIndex = activeIndex;
      this.$tabButtons.forEach((button, index) => {
        const active = index === activeIndex;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
        this.$panels[index].hidden = !active;
        this.$panels[index].inert = !active;
        this.$panels[index].setAttribute('aria-hidden', String(!active));
      });
      this.updateNavigation();
      this.scheduleLayout();
    }

    scheduleLayout() {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = requestAnimationFrame(() => {
        this.$titles.updateStyle();
        this.updateNavigation();
        const panel = this.$panels[this.selectedIndex];
        if (panel) {
          this.updateSwiper(panel);
        }
      });
    }

    updateNavigation() {
      const hasMultipleTabs = this.$tabButtons.length > 1;
      this.$scrollPrev.hidden = !hasMultipleTabs;
      this.$scrollNext.hidden = !hasMultipleTabs;
      this.$scrollPrev.disabled = this.selectedIndex === 0;
      this.$scrollNext.disabled = this.selectedIndex === this.$tabButtons.length - 1;
    }

    handleClick(event) {
      const tabArrow = event.target.closest('.yg-variant-tabs__scroll-prev, .yg-variant-tabs__scroll-next');
      if (tabArrow) {
        if (!tabArrow.disabled) {
          this.selectTab(this.selectedIndex + (tabArrow === this.$scrollPrev ? -1 : 1));
        }
        return;
      }
      const arrow = event.target.closest('[data-yg-swiper-prev], [data-yg-swiper-next]');
      if (arrow && !arrow.disabled) {
        const swiper = this.swipers.get(arrow.closest('.yg-variant-tabs__panel'));
        if (arrow.hasAttribute('data-yg-swiper-prev')) {
          swiper?.slidePrev();
        } else {
          swiper?.slideNext();
        }
      }
    }

    handleTabKeydown(event) {
      const index = this.$tabButtons.indexOf(event.target);
      if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        return;
      }
      event.preventDefault();
      let nextIndex = index;
      if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.$tabButtons.length - 1;
      } else {
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        nextIndex = (index + direction + this.$tabButtons.length) % this.$tabButtons.length;
      }
      this.selectTab(nextIndex);
      this.$tabButtons[nextIndex].focus({ preventScroll: true });
    }

    async handleOptionChange(event) {
      const input = event.target;
      if (!input.matches('[data-yg-options] input[data-option-position]')) {
        return;
      }
      const panel = input.closest('.yg-variant-tabs__panel');
      const state = this.panelStates.get(panel);
      const optionValues = this.getOptionValues(panel);
      const focusedId = input.id;
      const connectionId = this.connectionId;
      state.request?.abort();
      state.request = new AbortController();
      state.requestId += 1;
      const requestId = state.requestId;
      state.pending = true;
      panel.setAttribute('aria-busy', 'true');
      panel.querySelector('[data-yg-variant-error]').hidden = true;
      panel.querySelector('[name="id"]').value = '';
      panel.querySelector('[name="id"]').disabled = true;
      panel.querySelector('[data-yg-add-button]').disabled = true;
      const optionLabel = input.closest('fieldset').querySelector('label[for="' + CSS.escape(input.id) + '"]');
      input.closest('fieldset').querySelector('[data-yg-option-label]').textContent = optionLabel.textContent.trim();

      try {
        const url = new URL(panel.dataset.productUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('option_values', optionValues.join(','));
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) {
          url.searchParams.set('preview_theme_id', previewTheme);
        }
        const response = await fetch(url, { signal: state.request.signal });
        if (!response.ok) {
          throw new Error('Variant section request failed.');
        }
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || connectionId !== this.connectionId || requestId !== state.requestId) {
          return;
        }
        const nextPanel = html.getElementById(panel.id);
        if (!nextPanel) {
          throw new Error('Variant panel is missing.');
        }
        const nextVariant = this.getVariant(nextPanel);
        const returnedOptions = nextVariant.optionValues.map(String);
        if (returnedOptions.join(',') !== optionValues.join(',')) {
          throw new Error('Returned variant options do not match the selection.');
        }

        const options = panel.querySelector('[data-yg-options]');
        const nextOptions = nextPanel.querySelector('[data-yg-options]');
        options.replaceChildren(...nextOptions.childNodes);
        state.confirmedOptions = options.innerHTML;
        state.variant = nextVariant;
        this.destroySwiper(panel);
        panel.querySelector('[data-yg-extend]').replaceWith(nextPanel.querySelector('[data-yg-extend]'));
        panel.querySelector('[data-yg-variant-state]').textContent = JSON.stringify(nextVariant);
        state.pending = false;
        this.setVariant(panel, nextVariant);
        this.scheduleLayout();
        const focusedInput = options.querySelector('#' + CSS.escape(focusedId));
        if (this.$panels[this.selectedIndex] === panel && document.activeElement === document.body) {
          focusedInput?.focus({ preventScroll: true });
        }
      } catch (error) {
        if (
          error.name === 'AbortError' ||
          connectionId !== this.connectionId ||
          requestId !== state.requestId ||
          !this.isConnected
        ) {
          return;
        }
        panel.querySelector('[data-yg-options]').innerHTML = state.confirmedOptions;
        state.pending = false;
        this.setVariant(panel, state.variant);
        const errorMessage = panel.querySelector('[data-yg-variant-error]');
        errorMessage.textContent = this.dataset.errorMessage;
        errorMessage.hidden = false;
        this.scheduleLayout();
        if (this.$panels[this.selectedIndex] === panel && document.activeElement === document.body) {
          panel.querySelector('#' + CSS.escape(focusedId))?.focus({ preventScroll: true });
        }
      } finally {
        if (connectionId === this.connectionId && requestId === state.requestId && this.isConnected) {
          panel.removeAttribute('aria-busy');
        }
      }
    }

    setVariant(panel, variant) {
      const input = panel.querySelector('[name="id"]');
      const button = panel.querySelector('[data-yg-add-button]');
      if (!input || !button) {
        return;
      }
      input.value = variant.id || '';
      input.disabled = !variant.id;
      button.disabled = !variant.id || !variant.available;
      panel.querySelector('[data-yg-add-label]').textContent = !variant.id
        ? this.dataset.unavailableLabel
        : variant.available
        ? panel.dataset.addLabel
        : this.dataset.soldOutLabel;
      const extend = panel.querySelector('[data-yg-extend]');
      extend.hidden = !variant.id || !extend.querySelector('.swiper-slide');
    }

    updateSwiper(panel) {
      const state = this.panelStates.get(panel);
      const extend = panel.querySelector('[data-yg-extend]');
      if (state.pending || extend.hidden) {
        return;
      }
      const existingSwiper = this.swipers.get(panel);
      if (existingSwiper) {
        existingSwiper.update();
        this.updateSwiperControls(panel, existingSwiper);
        return;
      }
      const swiper = new Swiper(extend.querySelector('[data-yg-swiper]'), {
        slidesPerView: 2,
        spaceBetween: 12,
        watchOverflow: true,
        loop: false,
        breakpoints: {
          700: { slidesPerView: 3 },
          1000: { slidesPerView: 4 },
        },
        on: {
          init: (instance) => this.updateSwiperControls(panel, instance),
          slideChange: (instance) => this.updateSwiperControls(panel, instance),
          resize: (instance) => this.updateSwiperControls(panel, instance),
          lock: (instance) => this.updateSwiperControls(panel, instance),
          unlock: (instance) => this.updateSwiperControls(panel, instance),
        },
      });
      this.swipers.set(panel, swiper);
    }

    updateSwiperControls(panel, swiper) {
      panel.querySelector('[data-yg-swiper-prev]').disabled = swiper.isBeginning || swiper.isLocked;
      panel.querySelector('[data-yg-swiper-next]').disabled = swiper.isEnd || swiper.isLocked;
    }

    destroySwiper(panel) {
      this.swipers.get(panel)?.destroy(true, true);
      this.swipers.delete(panel);
    }
  }

  if (!customElements.get('yg-product-variant-tabs')) {
    customElements.define('yg-product-variant-tabs', YGProductVariantTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-roll-image-in-image"] && !Shopify.designMode) return;
  try {
    
  class YGRollImageInImage extends HTMLElement {
    constructor() {
      super();
      this.animationFrame = null;
      this.scrollListening = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleMotionPreference = this.handleMotionPreference.bind(this);
    }

    connectedCallback() {
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      window.addEventListener('resize', this.handleResize);
      this.motionQuery.addEventListener?.('change', this.handleMotionPreference);
      this.handleMotionPreference();
    }

    disconnectedCallback() {
      this.disableScrollTracking();
      window.removeEventListener('resize', this.handleResize);
      this.motionQuery?.removeEventListener?.('change', this.handleMotionPreference);

      if (this.animationFrame !== null) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }
    }

    handleMotionPreference() {
      if (this.motionQuery?.matches) {
        this.disableScrollTracking();
        this.style.setProperty('--mask-scale', '1');
        return;
      }

      this.enableScrollTracking();
      this.requestTick();
    }

    enableScrollTracking() {
      if (this.scrollListening) {
        return;
      }

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.scrollListening = true;
    }

    disableScrollTracking() {
      if (!this.scrollListening) {
        return;
      }

      window.removeEventListener('scroll', this.handleScroll);
      this.scrollListening = false;
    }

    handleScroll() {
      this.requestTick();
    }

    handleResize() {
      this.requestTick();
    }

    requestTick() {
      if (this.animationFrame !== null) {
        return;
      }

      this.animationFrame = requestAnimationFrame(() => this.updateProgress());
    }

    updateProgress() {
      this.animationFrame = null;

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollRange = Math.max(this.offsetHeight - viewportHeight, 1);
      const sectionRect = this.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -sectionRect.top / scrollRange));
      const easedProgress = progress * progress * (3 - 2 * progress);
      const endScale =
        Number.parseFloat(
          window.getComputedStyle(this).getPropertyValue('--mask-end-scale')
        ) || 2.2;
      const scale = 1 + (endScale - 1) * easedProgress;

      this.style.setProperty('--mask-scale', scale.toFixed(4));
    }
  }

  if (!customElements.get('yg-roll-image-in-image')) {
    customElements.define('yg-roll-image-in-image', YGRollImageInImage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-specifications"] && !Shopify.designMode) return;
  try {
    
  class YgSpecifications extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.navigationLinks = Array.from(this.querySelectorAll('[data-specification-nav-link]'));
      this.groups = Array.from(this.querySelectorAll('[data-specification-group]'));
      this.animatingGroups = new WeakSet();
      this.programmaticScroll = false;
      this.animationFrame = null;
      this.unlockTimer = null;
      this.handleNavigationClick = this.handleNavigationClick.bind(this);
      this.handleSummaryClick = this.handleSummaryClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.unlockProgrammaticScroll = this.unlockProgrammaticScroll.bind(this);
      this.syncStickyOffset = this.syncStickyOffset.bind(this);
      this.anchorSection =
        typeof document !== 'undefined' ? document.querySelector('.shopify-section.yg-anchor-tab') : null;

      this.syncStickyOffset();

      if (this.anchorSection && 'ResizeObserver' in window) {
        this.anchorResizeObserver = new ResizeObserver(this.syncStickyOffset);
        this.anchorResizeObserver.observe(this.anchorSection);
      }

      this.navigationLinks.forEach((link) => {
        link.addEventListener('click', this.handleNavigationClick);
      });

      this.groups.forEach((group) => {
        group.querySelector?.('summary')?.addEventListener('click', this.handleSummaryClick);
      });

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      this.updateActiveFromScroll();
    }

    disconnectedCallback() {
      this.navigationLinks?.forEach((link) => {
        link.removeEventListener('click', this.handleNavigationClick);
      });
      this.groups?.forEach((group) => {
        group.querySelector?.('summary')?.removeEventListener('click', this.handleSummaryClick);
      });
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scrollend', this.unlockProgrammaticScroll);
      this.anchorResizeObserver?.disconnect();

      if (this.animationFrame !== null) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }

      if (this.unlockTimer !== null) {
        clearTimeout(this.unlockTimer);
        this.unlockTimer = null;
      }

      delete this.dataset.initialized;
    }

    get prefersReducedMotion() {
      return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches === true;
    }

    syncStickyOffset() {
      const anchorHeight = this.anchorSection ? this.anchorSection.getBoundingClientRect().height : 0;

      this.style?.setProperty('--yg-anchor-tab-height', `${Math.round(anchorHeight)}px`);
      this.requestActiveUpdate();
    }

    handleScroll() {
      this.requestActiveUpdate();
    }

    handleResize() {
      this.requestActiveUpdate();
    }

    requestActiveUpdate() {
      if (this.animationFrame !== null) return;

      this.animationFrame = requestAnimationFrame(() => {
        this.animationFrame = null;
        if (this.programmaticScroll) return;
        this.updateActiveFromScroll();
      });
    }

    getStickyOffset() {
      const navigation = this.querySelector('.yg-specifications__navigation');
      if (!navigation) return 0;

      const stickyTop = parseFloat(getComputedStyle(navigation).top);
      return Number.isFinite(stickyTop) ? stickyTop : 0;
    }

    updateActiveFromScroll() {
      if (!this.groups?.length || !this.navigationLinks?.length) return;

      const navigation = this.querySelector('.yg-specifications__navigation');
      if (!navigation || getComputedStyle(navigation).display === 'none') return;

      // 当前项是最后一组已经越过吸顶线的标题。按相交区域里最靠上的区块来选，往上滚时更高的上一组会把较短的中间组挤掉。
      const line = this.getStickyOffset() + 8;
      let activeIndex = 0;

      this.groups.forEach((group, index) => {
        if (group.getBoundingClientRect().top <= line) activeIndex = index;
      });

      const activeLink = this.navigationLinks[activeIndex];
      if (activeLink) this.setActiveLink(activeLink);
    }

    handleSummaryClick(event) {
      const group = event.currentTarget.closest('[data-specification-group]');
      if (!group || this.animatingGroups.has(group)) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      this.setGroupOpen(group, !group.open);
    }

    handleNavigationClick(event) {
      event.preventDefault();

      const activeLink = event.currentTarget;
      const target = this.querySelector(activeLink.getAttribute('href'));

      if (!target) return;

      this.setGroupOpen(target, true);
      this.setActiveLink(activeLink);
      this.programmaticScroll = true;

      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - this.getStickyOffset());
      window.scrollTo({
        top,
        behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
      });

      window.removeEventListener('scrollend', this.unlockProgrammaticScroll);
      window.addEventListener('scrollend', this.unlockProgrammaticScroll, { once: true });

      if (this.unlockTimer !== null) window.clearTimeout(this.unlockTimer);
      this.unlockTimer = window.setTimeout(this.unlockProgrammaticScroll, this.prefersReducedMotion ? 50 : 800);
    }

    unlockProgrammaticScroll() {
      this.programmaticScroll = false;

      if (this.unlockTimer !== null) {
        window.clearTimeout(this.unlockTimer);
        this.unlockTimer = null;
      }

      window.removeEventListener('scrollend', this.unlockProgrammaticScroll);
      this.requestActiveUpdate();
    }

    setGroupOpen(group, open) {
      const isExpanded = group.classList?.contains?.('is-expanded') === true;
      if (Boolean(group.open) === open && isExpanded === open) return;

      const collapse = group.querySelector?.('.yg-specifications__collapse');
      group.classList?.toggle?.('is-expanded', open);

      if (!collapse || this.prefersReducedMotion) {
        group.open = open;
        if (collapse) collapse.style.height = open ? 'auto' : '0px';
        this.requestActiveUpdate();
        return;
      }

      this.animatingGroups.add(group);
      window.clearTimeout(group._specificationTimer);

      const finish = () => {
        if (open) collapse.style.height = 'auto';
        else group.open = false;
        this.animatingGroups.delete(group);
        this.requestActiveUpdate();
      };

      group._specificationTimer = window.setTimeout(finish, 320);

      if (open) {
        collapse.style.transition = 'none';
        collapse.style.height = '0px';
        group.open = true;
        const height = collapse.scrollHeight;
        collapse.offsetHeight;
        collapse.style.transition = '';
        collapse.style.height = `${height}px`;
        return;
      }

      collapse.style.transition = 'none';
      collapse.style.height = `${collapse.scrollHeight}px`;
      collapse.offsetHeight;
      collapse.style.transition = '';
      collapse.style.height = '0px';
    }

    setActiveLink(activeLink) {
      if (!activeLink || activeLink.getAttribute('aria-current') === 'true') return;

      this.navigationLinks.forEach((link) => {
        const isActive = link === activeLink;
        link.classList.toggle('is-active', isActive);

        if (isActive) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('yg-specifications')) {
    customElements.define('yg-specifications', YgSpecifications);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-story-swiper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-story-swiper')) {
    class YGStorySwiper extends HTMLElement {
      static apiPromises = new Map();

      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        this.track = this.querySelector('.yg-story-track');
        this.slides = Array.from(this.querySelectorAll('.yg-story-slide'));
        this.tabs = Array.from(this.querySelectorAll('.yg-story-tab'));
        this.panels = Array.from(this.querySelectorAll('.yg-story-content'));
        this.tabScroller = this.querySelector('.yg-story-tabs');
        this.mediaQuery = window.matchMedia('(max-width: 699px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;
        this.playbackToken = 0;
        this.visible = false;
        this.mediaState = null;
        const signal = this.abortController.signal;
        this.addEventListener('click', (event) => this.handleTabClick(event), { signal });
        this.addEventListener('keydown', (event) => this.handleTabKeydown(event), { signal });
        this.addEventListener(
          'shopify:block:select',
          (event) => {
            const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
            if (index !== -1) this.selectSlide(index);
          },
          { signal }
        );
        this.mediaQuery.addEventListener(
          'change',
          () => {
            this.stopMedia();
            this.startMedia();
          },
          { signal }
        );
        document.addEventListener(
          'visibilitychange',
          () => {
            this.stopMedia();
            this.startMedia();
          },
          { signal }
        );
        this.intersectionObserver = new IntersectionObserver((entries) => {
          const visible = entries[0].isIntersecting;
          if (visible === this.visible) return;
          this.visible = visible;
          this.stopMedia();
          this.startMedia();
        });
        this.intersectionObserver.observe(this.track);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (!this.isConnected) return;
            this.updateLoop();
            this.centerTab(false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.initSwiper();
      }

      disconnectedCallback() {
        this.stopMedia();
        this.abortController?.abort();
        this.abortController = null;
        this.intersectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.resizeFrame);
        clearTimeout(this.swiperTimer);
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }

      initSwiper() {
        if (!this.isConnected || !this.abortController) return;
        if (!window.Swiper) {
          this.swiperTimer = setTimeout(() => this.initSwiper(), 100);
          return;
        }
        if (!this.isConnected || this.swiper) return;
        this.track.classList.add('is-initializing');
        this.swiper = new Swiper(this.track, {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 16,
          slidesPerGroup: 1,
          loop: this.slides.length >= 3,
          rewind: this.slides.length === 2,
          speed: this.reducedMotion.matches ? 0 : 400,
          allowTouchMove: this.slides.length > 1,
          watchOverflow: false,
          on: {
            slideChange: (swiper) => {
              if (this.swiper) this.syncSlide(swiper.realIndex);
            },
            transitionEnd: (swiper) => {
              if (!this.swiper || !swiper.params.loop || this.fixingLoop) return;
              this.fixingLoop = true;
              swiper.loopFix();
              this.fixingLoop = false;
            },
            resize: () => this.updateLoop(),
          },
        });
        this.track.classList.remove('is-initializing');
        this.updateLoop();
        if (this.swiper.params.loop) this.swiper.slideTo(this.swiper.getSlideIndexByData(0), 0, false);
        this.syncSlide(0);
      }

      updateLoop() {
        if (!this.swiper || this.updatingLoop) return;
        this.updatingLoop = true;
        const swiper = this.swiper;
        swiper.update();
        const canLoop = this.slides.length >= 3;
        if (canLoop !== swiper.params.loop) {
          const index = this.activeIndex;
          this.stopMedia();
          if (swiper.params.loop) swiper.loopDestroy();
          swiper.params.loop = canLoop;
          swiper.params.rewind = !canLoop && this.slides.length > 1;
          if (canLoop) swiper.loopCreate(index);
          swiper.update();
          if (canLoop) swiper.slideToLoop(index, 0, false);
          else swiper.slideTo(index, 0, false);
          this.syncSlide(index);
          this.startMedia();
        }
        this.updatingLoop = false;
      }

      selectSlide(index) {
        if (!this.swiper) return;
        const swiper = this.swiper;
        const speed = this.reducedMotion.matches ? 0 : swiper.params.speed;
        if (!swiper.params.loop) {
          swiper.slideTo(index, speed);
          return;
        }
        const current = swiper.realIndex;
        const count = this.slides.length;
        if (index === (current + 1) % count) swiper.slideNext(speed);
        else if (index === (current - 1 + count) % count) swiper.slidePrev(speed);
        else swiper.slideToLoop(index, speed);
      }

      syncSlide(index) {
        const changed = index !== this.activeIndex;
        this.activeIndex = index;
        this.slides.forEach((slide) => {
          slide.classList.toggle('is-active', Number(slide.dataset.storyIndex) === index);
        });
        this.tabs.forEach((tab, tabIndex) => {
          tab.setAttribute('aria-selected', String(tabIndex === index));
          tab.tabIndex = tabIndex === index ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });
        this.centerTab(true);
        if (changed) this.stopMedia();
        this.startMedia();
      }

      centerTab(smooth) {
        const tab = this.tabs[this.activeIndex];
        if (!tab) return;
        const scroller = this.tabScroller;
        const left =
          tab.getBoundingClientRect().left -
          scroller.getBoundingClientRect().left +
          scroller.scrollLeft +
          tab.offsetWidth / 2 -
          scroller.clientWidth / 2;
        scroller.scrollTo({
          left: Math.max(0, Math.min(left, scroller.scrollWidth - scroller.clientWidth)),
          behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant',
        });
      }

      handleTabClick(event) {
        const tab = event.target.closest('.yg-story-tab');
        if (!tab || !this.contains(tab)) return;
        this.selectSlide(Number(tab.dataset.storyIndex));
      }

      handleTabKeydown(event) {
        const tab = event.target.closest('.yg-story-tab');
        if (!tab) return;
        const index = Number(tab.dataset.storyIndex);
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.tabs[nextIndex].focus({ preventScroll: true });
        this.selectSlide(nextIndex);
      }

      isCurrent(state) {
        return (
          this.isConnected &&
          this.mediaState === state &&
          state.token === this.playbackToken &&
          this.visible &&
          !document.hidden
        );
      }

      async startMedia() {
        if (!this.visible || document.hidden || this.mediaState || !this.abortController) return;
        const slide = this.slides[this.activeIndex];
        const viewport = this.mediaQuery.matches ? 'mobile' : 'desktop';
        const media = slide?.querySelector(`[data-viewport="${viewport}"]`);
        const component = media?.querySelector('yg-video');
        if (!component) return;
        const state = {
          token: ++this.playbackToken,
          media,
          component,
          progress: media.querySelector('.yg-story-progress'),
          abortController: new AbortController(),
        };
        this.mediaState = state;
        try {
          const template = component.querySelector('template');
          if (!template) throw new Error('Missing video template');
          template.content.querySelectorAll('video').forEach((video) => video.removeAttribute('autoplay'));
          const iframeTemplate = template?.content.querySelector('iframe');
          let provider;
          if (iframeTemplate) {
            const url = new URL(iframeTemplate.src);
            provider = url.hostname.includes('youtube') ? 'youtube' : 'vimeo';
            await YGStorySwiper.loadApi(provider);
            if (!this.isCurrent(state)) return;
            url.searchParams.set('autoplay', '0');
            url.searchParams.set('loop', '1');
            url.searchParams.set('controls', '0');
            url.searchParams.set(provider === 'youtube' ? 'mute' : 'muted', '1');
            iframeTemplate.src = url.toString();
          }
          const fragment = template.content.cloneNode(true);
          fragment.querySelectorAll('video').forEach((video) => video.removeAttribute('autoplay'));
          component.appendChild(fragment);
          const video = component.querySelector('video');
          if (video) {
            state.video = video;
            video.autoplay = false;
            video.muted = true;
            video.loop = true;
            video.controls = false;
            video.playsInline = true;
            video.currentTime = 0;
            video.addEventListener('playing', () => this.setPlaying(state, true), {
              signal: state.abortController.signal,
            });
            video.addEventListener('pause', () => this.setPlaying(state, false), {
              signal: state.abortController.signal,
            });
            await video.play();
            if (!this.isCurrent(state)) return;
            this.setPlaying(state, true);
            this.updateNativeProgress(state);
          } else {
            const iframe = component.querySelector('iframe');
            if (!iframe) throw new Error('Missing video iframe');
            iframe.title = this.tabs[this.activeIndex].textContent.trim();
            iframe.tabIndex = -1;
            if (provider === 'youtube') this.startYouTube(state, iframe);
            else await this.startVimeo(state, iframe);
          }
        } catch (error) {
          if (this.mediaState === state) this.stopMedia();
        }
      }

      setPlaying(state, playing) {
        if (!this.isCurrent(state)) return;
        state.media.classList.toggle('is-playing', playing);
        if (playing) state.progress?.classList.add('video-sync');
      }

      setProgress(state, seconds, duration) {
        if (!this.isCurrent(state) || !Number.isFinite(duration) || duration <= 0) return;
        const progress = Math.max(0, Math.min(100, (seconds / duration) * 100));
        state.progress?.style.setProperty('--progress-width', `${progress}%`);
      }

      updateNativeProgress(state) {
        if (!this.isCurrent(state)) return;
        this.setProgress(state, state.video.currentTime, state.video.duration);
        state.frame = requestAnimationFrame(() => this.updateNativeProgress(state));
      }

      startYouTube(state, iframe) {
        state.readyTimer = setTimeout(() => {
          if (this.mediaState === state) this.stopMedia();
        }, 15000);
        state.player = new window.YT.Player(iframe, {
          events: {
            onReady: (event) => {
              clearTimeout(state.readyTimer);
              if (!this.isCurrent(state)) {
                event.target.destroy();
                return;
              }
              event.target.mute();
              event.target.seekTo(0, true);
              event.target.playVideo();
              const update = () => {
                if (!this.isCurrent(state)) return;
                this.setProgress(state, event.target.getCurrentTime(), event.target.getDuration());
                state.frame = requestAnimationFrame(update);
              };
              update();
            },
            onStateChange: (event) => {
              if (!this.isCurrent(state)) return;
              this.setPlaying(state, event.data === window.YT.PlayerState.PLAYING);
              if (event.data === window.YT.PlayerState.ENDED) {
                this.setProgress(state, 0, 1);
                event.target.seekTo(0, true);
                event.target.playVideo();
              }
            },
            onError: () => {
              if (this.mediaState === state) this.stopMedia();
            },
          },
        });
      }

      async startVimeo(state, iframe) {
        state.player = new window.Vimeo.Player(iframe);
        state.readyTimer = setTimeout(() => {
          if (this.mediaState === state) this.stopMedia();
        }, 15000);
        await state.player.ready();
        clearTimeout(state.readyTimer);
        if (!this.isCurrent(state)) return;
        state.player.on('play', () => this.setPlaying(state, true));
        state.player.on('pause', () => this.setPlaying(state, false));
        state.player.on('timeupdate', (event) => this.setProgress(state, event.seconds, event.duration));
        state.player.on('error', () => {
          if (this.mediaState === state) this.stopMedia();
        });
        await state.player.setMuted(true);
        if (!this.isCurrent(state)) return;
        await state.player.setLoop(true);
        if (!this.isCurrent(state)) return;
        await state.player.setCurrentTime(0);
        if (!this.isCurrent(state)) return;
        await state.player.play();
      }

      stopMedia() {
        ++this.playbackToken;
        const state = this.mediaState;
        this.mediaState = null;
        if (!state) return;
        state.abortController.abort();
        cancelAnimationFrame(state.frame);
        clearTimeout(state.readyTimer);
        state.media.classList.remove('is-playing');
        state.progress?.style.setProperty('--progress-width', '0%');
        if (state.video) {
          state.video.pause();
          try {
            state.video.currentTime = 0;
          } catch (error) {
            // Metadata may not be available yet.
          }
        }
        if (state.player) {
          try {
            const destroyed = state.player.destroy();
            destroyed?.catch?.(() => {});
          } catch (error) {
            // A player may already have removed its iframe.
          }
        }
        state.component.querySelector('.yg-video-iframe-container')?.remove();
      }

      static loadApi(provider) {
        const isReady = () => (provider === 'youtube' ? window.YT?.Player : window.Vimeo?.Player);
        if (isReady()) return Promise.resolve();
        if (this.apiPromises.has(provider)) return this.apiPromises.get(provider);
        const promise = new Promise((resolve, reject) => {
          const src =
            provider === 'youtube' ? 'https://www.youtube.com/iframe_api' : 'https://player.vimeo.com/api/player.js';
          let script = Array.from(document.scripts).find((element) => element.src === src);
          const createdScript = !script;
          const onError = () => finish(new Error('Video API unavailable'));
          const finish = (error) => {
            clearInterval(timer);
            script.removeEventListener('error', onError);
            if (error && createdScript) script.remove();
            if (error) reject(error);
            else resolve();
          };
          let attempts = 0;
          const timer = setInterval(() => {
            if (isReady()) finish();
            else if (++attempts >= 150) finish(new Error('Video API timed out'));
          }, 100);
          if (!script) {
            script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.addEventListener('error', onError, { once: true });
            document.head.appendChild(script);
          } else {
            script.addEventListener('error', onError, { once: true });
          }
        }).catch((error) => {
          this.apiPromises.delete(provider);
          throw error;
        });
        this.apiPromises.set(provider, promise);
        return promise;
      }
    }

    customElements.define('yg-story-swiper', YGStorySwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-swiper-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
        this.onKeyDown = (event) => {
          if (event.target !== this) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(this).direction === 'rtl';
            const next = (event.key === 'ArrowRight') !== rtl;
            if (next) this.swiper.slideNext();
            else this.swiper.slidePrev();
          }
        };
        this.addEventListener('keydown', this.onKeyDown);
      }
      disconnectedCallback() {
        this.removeEventListener('keydown', this.onKeyDown);
        if (this.swiper) this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-03"] && !Shopify.designMode) return;
  try {
    
  class YGTabs03 extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.mediaSwiper = null;
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
      this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) return this._sectionElements;

      this._sectionElements = {
        tabsTrack: this.querySelector('[data-tabs-track]'),
        tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
        tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
        mediaSwiper: this.querySelector('[data-media-swiper]'),
        mediaSlides: Array.from(this.querySelectorAll('.yg-tabs-03__media-slide')),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionElements.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick));
      this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
      window.addEventListener('resize', this.handleResize);
      this.mountSwiper();
    }

    disconnectedCallback() {
      this.sectionElements.tabs.forEach((tab) => tab.removeEventListener('click', this.handleTabClick));
      this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
      window.removeEventListener('resize', this.handleResize);

      if (this.mediaSwiper) {
        this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
        this.mediaSwiper = null;
      }

      this.initialized = false;
    }

    mountSwiper(attempt = 0) {
      const mediaSwiperElement = this.sectionElements.mediaSwiper;
      if (!mediaSwiperElement) return;

      if (!mediaSwiperElement.swiper) {
        if (attempt < 10) window.setTimeout(() => this.mountSwiper(attempt + 1), 150);
        return;
      }

      this.mediaSwiper = mediaSwiperElement.swiper;
      this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
      this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.setActiveState(0, { syncSwiper: false, scrollBehavior: 'auto' });
    }

    handleTabClick(event) {
      this.setActiveState(Number(event.currentTarget.dataset.tabIndex));
    }

    handleTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      const currentIndex = this.activeIndex;
      const lastIndex = this.sectionElements.tabs.length - 1;
      let nextIndex = currentIndex;

      if (event.key === 'ArrowLeft') nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
      else if (event.key === 'ArrowRight') nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = lastIndex;

      event.preventDefault();
      const nextTab = this.sectionElements.tabs[nextIndex];
      if (nextTab) nextTab.focus();
      this.setActiveState(nextIndex);
    }

    handleMediaSlideChange() {
      const nextIndex =
        typeof this.mediaSwiper.realIndex === 'number' ? this.mediaSwiper.realIndex : this.mediaSwiper.activeIndex;
      this.setActiveState(nextIndex, { syncSwiper: false });
    }

    handleResize() {
      this.updateOverflowState();

      if (this.isTabsOverflowing()) this.scrollActiveTabIntoView('auto');
      else if (this.sectionElements.tabsScrollContainer) this.sectionElements.tabsScrollContainer.scrollLeft = 0;
    }

    isTabsOverflowing() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;
      return scrollContainer ? scrollContainer.scrollWidth > scrollContainer.clientWidth + 1 : false;
    }

    scrollActiveTabIntoView(behavior = 'smooth') {
      const scrollContainer = this.sectionElements.tabsScrollContainer;
      const activeTab = this.sectionElements.tabs[this.activeIndex];
      if (!activeTab || !scrollContainer || !this.isTabsOverflowing()) return;

      const containerRect = scrollContainer.getBoundingClientRect();
      const itemRect = activeTab.getBoundingClientRect();
      const rawScrollLeft =
        scrollContainer.scrollLeft +
        (itemRect.left - containerRect.left) -
        (scrollContainer.clientWidth - itemRect.width) / 2;
      const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
      const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

      if (typeof scrollContainer.scrollTo === 'function') {
        scrollContainer.scrollTo({ left: nextScrollLeft, behavior: behavior });
      } else {
        scrollContainer.scrollLeft = nextScrollLeft;
      }
    }

    updateOverflowState() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;
      if (scrollContainer) scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
    }

    pauseAllVideos() {
      this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
        if (typeof videoElement.pauseVideo === 'function') videoElement.pauseVideo();
      });
    }

    playActiveVideo() {
      this.pauseAllVideos();
      const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
      const activeVideo = activeSlide?.querySelector('yg-video');
      if (activeVideo && typeof activeVideo.playVideo === 'function') activeVideo.playVideo();
    }

    setActiveState(index, options = {}) {
      const lastIndex = Math.max(this.sectionElements.mediaSlides.length - 1, 0);
      index = Math.max(0, Math.min(index, lastIndex));
      const syncSwiper = options.syncSwiper !== false;
      const scrollBehavior = options.scrollBehavior || 'smooth';
      this.activeIndex = index;

      if (syncSwiper && this.mediaSwiper && this.mediaSwiper.activeIndex !== index) {
        this.mediaSwiper.slideTo(index);
      }

      this.sectionElements.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.sectionElements.mediaSlides.forEach((slide, slideIndex) => {
        if (this.sectionElements.tabs.length > 0) {
          slide.setAttribute('role', 'tabpanel');
          slide.removeAttribute('aria-roledescription');
          slide.removeAttribute('aria-label');
          slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
        }
      });

      this.updateOverflowState();
      if (this.isTabsOverflowing()) this.scrollActiveTabIntoView(scrollBehavior);
      else if (this.sectionElements.tabsScrollContainer) this.sectionElements.tabsScrollContainer.scrollLeft = 0;
      this.playActiveVideo();
    }
  }

  if (!window.customElements.get('yg-tabs-03')) window.customElements.define('yg-tabs-03', YGTabs03);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-touch-tab"] && !Shopify.designMode) return;
  try {
    
  class YGTouchTabs extends HTMLElement {
    constructor() {
      super();
      this.swipers = new Map();
      this.desktopTitles = [];
      this.mobileTitles = [];
      this.panels = [];
      this.handleClick = this.handleClick.bind(this);
      this.handlePointerEnter = this.handlePointerEnter.bind(this);
      this.handleFocusIn = this.handleFocusIn.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleMobileScroll = this.handleMobileScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.desktopMedia = window.matchMedia(this.dataset.desktopQuery || '(min-width: 700px)');

      this.addEventListener('click', this.handleClick, true);
      this.addEventListener('pointerenter', this.handlePointerEnter, true);
      this.addEventListener('focusin', this.handleFocusIn);
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      if (typeof this.desktopMedia.addEventListener === 'function') {
        this.desktopMedia.addEventListener('change', this.handleBreakpointChange);
      } else {
        this.desktopMedia.addListener(this.handleBreakpointChange);
      }

      requestAnimationFrame(() => {
        this.cacheElements();
        this.activate(0);
      });
    }

    cacheElements() {
      this.desktopTitles = Array.from(this.querySelectorAll('.yg-touch-tab__desktop-title'));
      this.mobileTitles = Array.from(this.querySelectorAll('.yg-touch-tab__mobile-title'));
      this.panels = Array.from(this.querySelectorAll('.yg-touch-tab__panel'));
      this.mobileTabs = this.querySelector('.yg-touch-tab__mobile-tabs');
      this.mobileScrollContainer = this.mobileTabs?.querySelector('.yg-scroll-container');

      if (this.mobileScrollContainer && !this.mobileScrollBound) {
        this.mobileScrollBound = true;
        this.mobileScrollContainer.addEventListener('scroll', this.handleMobileScroll, { passive: true });
        if (typeof ResizeObserver === 'function') {
          this.mobileResizeObserver = new ResizeObserver(() => this.updateMobileMasks());
          this.mobileResizeObserver.observe(this.mobileScrollContainer);
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick, true);
      this.removeEventListener('pointerenter', this.handlePointerEnter, true);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.mobileScrollContainer?.removeEventListener('scroll', this.handleMobileScroll);
      window.removeEventListener('resize', this.handleResize);
      this.mobileResizeObserver?.disconnect();
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);

      if (this.desktopMedia) {
        if (typeof this.desktopMedia.removeEventListener === 'function') {
          this.desktopMedia.removeEventListener('change', this.handleBreakpointChange);
        } else {
          this.desktopMedia.removeListener(this.handleBreakpointChange);
        }
      }

      this.destroySwipers();
      this.initialized = false;
    }

    handleClick(event) {
      this.cacheElements();
      const prevButton = event.target.closest('[data-tab-scroll-prev]');
      const nextButton = event.target.closest('[data-tab-scroll-next]');
      if (prevButton || nextButton) {
        event.preventDefault();
        event.stopPropagation();
        const activeIndex = this.mobileTitles.findIndex((title) => title.classList.contains('is-active'));
        const nextIndex = prevButton
          ? Math.max(activeIndex - 1, 0)
          : Math.min(activeIndex + 1, this.mobileTitles.length - 1);
        this.activate(nextIndex);
        return;
      }

      const title = event.target.closest('.yg-touch-tab__desktop-title, .yg-touch-tab__mobile-title');
      if (!title || !this.contains(title)) return;
      event.stopPropagation();
      this.activate(Number(title.dataset.tabIndex));
    }

    handlePointerEnter(event) {
      if (!this.desktopMedia.matches) return;
      const title = event.target.closest('.yg-touch-tab__desktop-title');
      if (title) this.activate(Number(title.dataset.tabIndex));
    }

    handleFocusIn(event) {
      if (!this.desktopMedia.matches) return;
      const title = event.target.closest('.yg-touch-tab__desktop-title');
      if (title) this.activate(Number(title.dataset.tabIndex));
    }

    handleBreakpointChange(event) {
      const activeIndex = this.panels.findIndex((panel) => panel.classList.contains('is-active'));
      if (!event.matches) this.destroySwipers();
      requestAnimationFrame(() => this.activate(Math.max(activeIndex, 0)));
    }

    handleBlockSelect(event) {
      const block = event.target.closest('[data-block-id]');
      if (!block || !this.contains(block)) return;
      const index = this.panels.findIndex((panel) => panel.dataset.blockId === block.dataset.blockId);
      if (index >= 0) this.activate(index);
    }

    handleMobileScroll() {
      this.updateMobileMasks();
    }

    handleResize() {
      this.cacheElements();
      const activeIndex = this.mobileTitles.findIndex((title) => title.classList.contains('is-active'));
      this.updateMobileNav(Math.max(activeIndex, 0), false);
    }

    activate(index) {
      this.cacheElements();
      if (!Number.isInteger(index) || index < 0 || index >= this.panels.length) return;

      const currentIndex = this.panels.findIndex((panel) => panel.classList.contains('is-active'));
      if (currentIndex === index) {
        this.updateMobileNav(index, false);
        if (this.desktopMedia.matches) {
          requestAnimationFrame(() => this.ensureSwiper(this.panels[index]));
        }
        return;
      }

      [...this.desktopTitles, ...this.mobileTitles].forEach((title) => {
        const active = Number(title.dataset.tabIndex) === index;
        title.classList.toggle('is-active', active);
        title.setAttribute('aria-selected', String(active));
      });

      this.panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.classList.toggle('is-flashing', active && currentIndex >= 0);
        panel.setAttribute('aria-hidden', String(!active));
        panel.toggleAttribute('inert', !active);
      });

      const nextPanel = this.panels[index];
      if (nextPanel.classList.contains('is-flashing')) {
        nextPanel.addEventListener('animationend', () => nextPanel.classList.remove('is-flashing'), { once: true });
      }

      this.updateMobileNav(index, true);

      if (this.desktopMedia.matches) {
        requestAnimationFrame(() => this.ensureSwiper(this.panels[index]));
      }
    }

    updateMobileNav(index, animate = true) {
      this.updateMobileArrows(index);
      const sync = (shouldAnimate = false) => {
        this.updateMobileIndicator(index);
        this.scrollMobileTab(index, shouldAnimate);
        this.updateMobileMasks();
      };
      requestAnimationFrame(() => {
        sync(animate);
        requestAnimationFrame(() => sync(false));
      });
      if (document.fonts?.ready) document.fonts.ready.then(() => sync(false));
    }

    updateMobileIndicator(index) {
      const mobileTitle = this.mobileTitles[index];
      const titleContainer = mobileTitle?.closest('yg-tabs-title');
      if (!mobileTitle || !titleContainer) return;
      titleContainer.style.setProperty('--scroll-item-left', `${mobileTitle.offsetLeft}px`);
      titleContainer.style.setProperty('--scroll-item-width', `${mobileTitle.offsetWidth}px`);
    }

    updateMobileArrows(index) {
      const prevButton = this.querySelector('[data-tab-scroll-prev]');
      const nextButton = this.querySelector('[data-tab-scroll-next]');
      const lastIndex = this.mobileTitles.length - 1;

      if (prevButton) {
        prevButton.disabled = index <= 0 || lastIndex <= 0;
      }
      if (nextButton) {
        nextButton.disabled = index >= lastIndex || lastIndex <= 0;
      }
    }

    updateMobileMasks() {
      this.cacheElements();
      const tabs = this.mobileTabs;
      const scrollContainer = this.mobileScrollContainer;
      if (!tabs || !scrollContainer) return;

      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
      const epsilon = 2;
      tabs.classList.toggle('has-overflow-left', scrollLeft > epsilon);
      tabs.classList.toggle('has-overflow-right', scrollLeft + clientWidth < scrollWidth - epsilon);
    }

    scrollMobileTab(index, animate = true) {
      const title = this.mobileTitles[index];
      const scrollContainer = this.mobileScrollContainer;
      if (!title || !scrollContainer) return;

      const lastIndex = this.mobileTitles.length - 1;
      let nextScrollLeft = 0;

      if (index <= 0) {
        nextScrollLeft = 0;
      } else if (index >= lastIndex) {
        nextScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      } else {
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = title.getBoundingClientRect();
        nextScrollLeft =
          scrollContainer.scrollLeft +
          (itemRect.left - containerRect.left) -
          (scrollContainer.clientWidth - itemRect.width) / 2;
      }

      const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
      nextScrollLeft = Math.min(Math.max(nextScrollLeft, 0), maxScrollLeft);

      if (typeof scrollContainer.scrollTo === 'function') {
        scrollContainer.scrollTo({
          left: nextScrollLeft,
          behavior: animate ? 'smooth' : 'auto',
        });
      } else {
        scrollContainer.scrollLeft = nextScrollLeft;
      }
    }

    ensureSwiper(panel) {
      const container = panel?.querySelector('.yg-touch-tab__products');
      if (!container || Number(container.dataset.productCount) <= 3 || typeof Swiper === 'undefined') return;

      const current = this.swipers.get(panel);
      if (current) {
        current.update();
        return;
      }

      const swiper = new Swiper(container, {
        slidesPerView: 3,
        spaceBetween: 12,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        autoHeight: true,
        navigation: {
          prevEl: container.querySelector('.yg-touch-tab__carousel-button--prev'),
          nextEl: container.querySelector('.yg-touch-tab__carousel-button--next'),
        },
        breakpoints: {
          700: { slidesPerView: 2, spaceBetween: 12 },
          1000: { slidesPerView: 3, spaceBetween: 12 },
        },
      });

      this.swipers.set(panel, swiper);
    }

    destroySwipers() {
      this.swipers.forEach((swiper) => swiper.destroy(true, true));
      this.swipers.clear();
    }
  }

  if (!customElements.get('yg-touch-tabs')) {
    customElements.define('yg-touch-tabs', YGTouchTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-swiper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-video-swiper')) {
    class YGVideoSwiper extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
        this.track = null;
        this.handleSlideChange = this.stopVideos.bind(this, null);
        this.handleNavigationUpdate = this.updateNavigation.bind(this);
        this.handleBeforePlay = this.beforePlay.bind(this);
        this.handleKeydown = this.activateFromKeyboard.bind(this);
        this.handleBlockSelect = this.selectBlock.bind(this);
      }

      connectedCallback() {
        if (this.swiper) return;
        this.track = this.querySelector('.yg-video-swiper-track');
        if (!this.track) return;
        this.swiper = this.initSwiper(this.track);
        this.preparePlayers();
        this.swiper.on('slideChange', this.handleSlideChange);
        this.prepareNavigation();
        this.swiper.on('toEdge fromEdge lock unlock breakpoint', this.handleNavigationUpdate);
        this.addEventListener('click', this.handleBeforePlay, true);
        this.addEventListener('keydown', this.handleKeydown, true);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      disconnectedCallback() {
        this.stopVideos();
        this.removeEventListener('click', this.handleBeforePlay, true);
        this.removeEventListener('keydown', this.handleKeydown, true);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        if (this.swiper) {
          this.swiper.off('slideChange', this.handleSlideChange);
          this.swiper.off('toEdge fromEdge lock unlock breakpoint', this.handleNavigationUpdate);
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        this.track = null;
      }

      prepareNavigation() {
        const trackId = this.track.id;
        for (const [selector, label] of [
          ['.swiper-button-prev', this.dataset.prevLabel],
          ['.swiper-button-next', this.dataset.nextLabel],
        ]) {
          const button = this.querySelector(selector);
          if (!button) continue;
          button.classList.add('radius-full');
          button.setAttribute('role', 'button');
          button.setAttribute('aria-label', label);
          button.setAttribute('aria-controls', trackId);
          button.querySelector('svg')?.setAttribute('aria-hidden', 'true');
        }
        this.updateNavigation();
      }

      updateNavigation() {
        if (!this.swiper) return;
        const canWrap = this.swiper.params.loop || this.swiper.params.rewind;
        for (const [selector, isAtEdge] of [
          ['.swiper-button-prev', this.swiper.isBeginning],
          ['.swiper-button-next', this.swiper.isEnd],
        ]) {
          const button = this.querySelector(selector);
          if (!button) continue;
          const isDisabled = this.swiper.isLocked || (!canWrap && isAtEdge);
          button.setAttribute('aria-disabled', String(isDisabled));
          button.tabIndex = isDisabled ? -1 : 0;
        }
      }

      preparePlayers() {
        this.querySelectorAll('yg-video').forEach((player) => {
          const label = player.closest('.yg-video-swiper-media').dataset.playLabel;
          const play = player.querySelector('.yg-play');
          if (play) {
            play.setAttribute('role', 'button');
            play.setAttribute('aria-label', label);
            play.tabIndex = 0;
            if (player.dataset.popup === 'true') play.setAttribute('aria-haspopup', 'dialog');
          }
          const template = player.querySelector('template');
          template?.content.querySelectorAll('video').forEach((video) => {
            video.removeAttribute('muted');
            video.muted = false;
            video.setAttribute('controls', '');
          });
          template?.content.querySelectorAll('iframe').forEach((iframe) => {
            iframe.title = label;
            const url = new URL(iframe.getAttribute('src'), window.location.href);
            url.searchParams.set('controls', '1');
            url.searchParams.set('loop', '0');
            if (url.hostname === 'player.vimeo.com') {
              url.searchParams.set('background', '0');
              url.searchParams.set('muted', '0');
            } else {
              url.searchParams.set('mute', '0');
            }
            iframe.src = url.toString();
          });
        });
      }

      stopVideos(exceptPlayer) {
        this.querySelectorAll('yg-video').forEach((player) => {
          if (player === exceptPlayer || player.dataset.popup === 'true' || !player.videoContainer) return;
          player.pauseVideo?.();
        });
      }

      beforePlay(event) {
        const play = event.target.closest('.yg-play');
        if (!play || !this.contains(play)) return;
        if (this.swiper && !this.swiper.allowClick) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        this.stopVideos(play.closest('yg-video'));
      }

      activateFromKeyboard(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const button = event.target.closest('.yg-play, .swiper-button-prev, .swiper-button-next');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        if (!button.classList.contains('yg-play')) event.stopPropagation();
        if (button.getAttribute('aria-disabled') === 'true' || button.classList.contains('swiper-button-lock')) return;
        button.click();
      }

      selectBlock(event) {
        const slides = Array.from(this.querySelectorAll('.swiper-slide'));
        const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
        if (index === -1 || !this.swiper) return;
        this.swiper.slideTo(index, 0);
      }
    }

    customElements.define('yg-video-swiper', YGVideoSwiper);
  }

  } catch(e) { console.error(e); }
})();
})();
